// extracted by mini-css-extract-plugin
export default {"DayScroll":"styles_DayScroll__5OGTk","dark":"styles_dark__G2Fh7","light":"styles_light__bYSCu","selected":"styles_selected__uVrBi","available":"styles_available__rbGw-"};